// 预约负责人
import { useMark, useSwitch } from "Hooks/basic"
import React, { useEffect, useMemo } from "react"
import gql from "graphql-tag"
import { useLazyQuery } from "@apollo/react-hooks"
import { ComponentProps } from "./index"
import { groupAuthor } from "Methods/author"

const generateQuery = () => {
    // 过滤删除的作者和未绑定用户的作者
    const tableName = "author"
    return gql`
        query ${tableName}_list  {
            ${tableName} (order_by: {name: asc} where: {uid: {_is_null: false}, hidden: {_eq: false}}) {
                id
                name
                uid
                user_public {
                    department {
                        name
                        id
                    }
                }
            }
        }
    `
}

export function useChargeSelect(props: ComponentProps) {
    const { handleChangeAuthor, chargePerson } = props
    const { open, handleOpen, handleClose } = useSwitch(false)
    const query = generateQuery()
    const [ fetchAuthor, { data } ] = useLazyQuery(query, { fetchPolicy: "network-only" })
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.nativeEvent.stopImmediatePropagation()
        fetchAuthor()
        handleOpen()
    }
    const { author }  = data || {}
    const { authorList } = useMemo(
        () => groupAuthor(author),
        [author],
    )
    const { mark: chargeName, handleChangeMark: handleSetCharge } = useMark(chargePerson)
    const { mark: openIndex, handleChangeMark: handleChangeOpenIndex } = useMark(-1)
    const handleMenuItemClick = (name: string, author?: { uid: string, id: number})  => {
        handleSetCharge(name)
        handleClose()
        handleChangeOpenIndex(-1)
        if (author) {
            const { uid, id } = author
            handleChangeAuthor({
                principalId: uid,
                authorId: id,
            })
        }
    }
    // 注册全局关闭弹窗事件
    useEffect(() => {
        if (document) {
            document.addEventListener("click", () => {
                handleClose()
            })
        }
        return () => {
            document.removeEventListener("click", () => {})
        }
        // eslint-disable-next-line
    }, [])
    return {
        open, handleClick, handleMenuItemClick,
        chargeName, handleSetCharge, authorList,
        openIndex, handleChangeOpenIndex,
    }
}
